import { FieldRenderProps } from "@progress/kendo-react-form";
import { FunctionComponent } from "react";
import { Label } from "@progress/kendo-react-labels";
import { DropDownTree, DropDownTreeChangeEvent, DropDownTreeExpandEvent } from "@progress/kendo-react-dropdowns";
import { TicketApi } from "../../../redux/api/TicketApi";
import React from "react";
import { expandedState, processTreeData } from "../../../utils/TreeDataOperations";
import { IQuickNote } from "../../../types/Ticket/IQuickNotes";
import { Button } from "@progress/kendo-react-buttons";
import AddQuickNote from "./AddQuickNote";
import { Api } from "../../../redux/api/BaseApi";
import './QuickNotes.css'

const QuickNotesList: FunctionComponent<FieldRenderProps> = props => {
    const {
        quickNoteId,
        label,
        id,
        valid,
        disabled,
        optional,
    } = props;
    const selectField = "selected";
    const expandField = "expanded";
    const dataItemKey = "Id";
    const subItemsField = "QuickNotes";
    const { data: userProfile } = Api.useGetUserProfileQuery();
    const fields = { selectField, expandField, dataItemKey, subItemsField };
    const { data: quickNotes, refetch } = TicketApi.useGetQuickNotesQuery();
    const [refetchQuicknotes] = TicketApi.useRefetchQuicknotesMutation();
    const selectedQuickNote = quickNotes?.map(q => q.QuickNotes.find(qn => qn.Id === quickNoteId)).find(qn => qn?.Id === quickNoteId);
    const [value, setValue] = React.useState<IQuickNote>(selectedQuickNote);
    const [expanded, setExpanded] = React.useState(quickNotes?.length > 0 ? [quickNotes?.[0][dataItemKey]] : []);
    const [open, setOpen] = React.useState<boolean>();
    const [popupVisible, setPopupVisible] = React.useState<boolean>();

    const onChange = (event: DropDownTreeChangeEvent) => {

        //console.log('onChange', event, expanded.includes(event?.value?.Id))
        if (event?.value && event?.value.QuickNotes) {
            //console.log('cat');
            if (!expanded.includes(event?.value.Id))
                setExpanded([event?.value.Id]); //expand
            else
                //let newArray = [...expanded].splice(expanded.indexOf(event?.value.Id)
                setExpanded((oldVal) => {
                    let newVal = [...oldVal]
                    newVal.splice(expanded.indexOf(event?.value.Id), 1)
                    return newVal;
                }); //collaps
            setOpen(true); //stay open

            return
        }

        setValue(event.value);
        props.onChange(event);
        setOpen(undefined); //Close
    }
    const onExpandChange = React.useCallback(
        (event: DropDownTreeExpandEvent) =>
            setExpanded(expandedState(event.item, dataItemKey, expanded)),
        [expanded]
    );

    const treeData = React.useMemo(
        () => {
            return processTreeData(quickNotes || [], { expanded, value }, fields)
        },

        [quickNotes, expanded, value]
    );

    //After a quicknote has beem saved
    const [newId, setNewId] = React.useState<number>(null)
    const quickNoteSaved = (id: number) => {
        setPopupVisible(false);
        setNewId(id)
        refetch()
    }

    return (
        <>
            <Label
                editorId={id}
                editorValid={valid}
                editorDisabled={disabled}
                optional={optional}
            >
                {label}
            </Label>
            <div className={"flex"}>
                <DropDownTree data={treeData}
                    onBlur={() => setOpen(undefined)}
                    opened={open}
                    placeholder="Select..."
                    value={selectedQuickNote}
                    dataItemKey="Id"
                    textField="Name"
                    subItemsField="QuickNotes"
                    onChange={onChange}
                    selectField={selectField}
                    expandField={expandField}
                    onExpandChange={onExpandChange}
                    popupSettings={{ width: 500, className: 'quick-note-dropdown' }}
                />
                {userProfile?.Features.Add_Quick_Note && <Button icon='add' title="Add Quick Note" onClick={() => setPopupVisible(true)} formNoValidate={true}></Button>}
                {popupVisible && <AddQuickNote onClose={() => setPopupVisible(false)} onSave={(id) => quickNoteSaved(id)} />}
            </div>
        </>
    )
}

export default QuickNotesList;